import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-606cf489"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Condition", -1))
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 2 }
const _hoisted_5 = { key: 3 }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 4 }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { key: 2 }
const _hoisted_12 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    (_ctx.type === 'PAYMENT')
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.condition, (item, index) => {
          return (_openBlock(), _createElementBlock("div", { key: index }, [
            (item.firstPayment)
              ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(index + 1) + ". For first " + _toDisplayString(_ctx.data?.firstPayment) + " payments only. ", 1))
              : _createCommentVNode("", true),
            (item.paymentAmount)
              ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(index + 1) + ". More than " + _toDisplayString(_ctx.data?.paymentAmount) + " THB. ", 1))
              : _createCommentVNode("", true),
            (item.actionPeriod)
              ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(index + 1) + ". Payment within " + _toDisplayString(_ctx.data?.actionPeriod) + " days after registration. ", 1))
              : _createCommentVNode("", true),
            (item.package)
              ? (_openBlock(), _createElementBlock("p", _hoisted_5, [
                  _createTextVNode(_toDisplayString(index + 1) + ". Only ", 1),
                  (_ctx.data.package.length > 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.capitalize(_ctx.data?.package[0] || "-")) + " , " + _toDisplayString(_ctx.capitalize(_ctx.data?.package[1] || "-")) + " , " + _toDisplayString(_ctx.capitalize(_ctx.data?.package[2] || "-")) + " , ", 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_7, " - ")),
                  _createElementVNode("span", null, _toDisplayString(_ctx.capitalize(_ctx.data.type)) + " Package.", 1)
                ]))
              : _createCommentVNode("", true),
            (item.packagePeriod)
              ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(index + 1) + ". Doing action within " + _toDisplayString(_ctx.data?.packagePeriod) + " days. ", 1))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      : (_ctx.type === 'CREATE_MERCHANT')
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.condition, (item, index) => {
            return (_openBlock(), _createElementBlock("div", { key: index }, [
              (item.merchantType)
                ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(index + 1) + ". " + _toDisplayString(_ctx.capitalize(_ctx.data?.merchantType || "-")) + " business only. ", 1))
                : _createCommentVNode("", true),
              (item.firstMerchant)
                ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(index + 1) + ". For first " + _toDisplayString(_ctx.data?.firstMerchant || "-") + " merchants only. ", 1))
                : _createCommentVNode("", true),
              (item.actionPeriod)
                ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(index + 1) + ". Create Merchant within " + _toDisplayString(_ctx.data?.actionPeriod || "-") + " days after registration. ", 1))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.condition, (item, index) => {
            return (_openBlock(), _createElementBlock("div", { key: index }, [
              (item.userType)
                ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(index + 1) + ". " + _toDisplayString(_ctx.capitalize(_ctx.data?.userType || "-")) + " only. ", 1))
                : _createCommentVNode("", true)
            ]))
          }), 128))
  ], 64))
}